export default function ({ store }) {
  // Инициализация авторизации при загрузке приложения
  if (process.client) {
    store.dispatch('auth/loadAuthData')
  }
}
